export const SKIN_STORAGE_KEY = 'my-blog-skin';

// Keep presentation metadata in one place; adding a skin never changes a route.
export const SKINS = [
  { id: 'regular', name: '常规', description: '现在熟悉的云朵与色彩', color: '#f6f4fb' },
  { id: 'dynamic', name: '云间流转', description: '时光推荐 · 沿着记录慢慢读', color: '#eaf5fb' },
  { id: 'orbital', name: '星际航行', description: '天文图册 · 把好奇心写进航线', color: '#eef3f1' },
  { id: 'terminal', name: '苹果终端', description: '阅读工作台 · 一扇安静的桌面窗口', color: '#edf0f4' },
  { id: 'atelier', name: '纸间手记', description: '纸上季刊 · 收藏日常的细微光亮', color: '#f6f3eb' },
];

export const isSkin = value => SKINS.some(skin => skin.id === value);
export const getSkin = value => SKINS.find(skin => skin.id === value) || SKINS[0];
export const getSkinColor = (skin, period) => skin === 'dynamic'
  ? ({ day: '#eaf5fb', dusk: '#f5d8ca', night: '#172238' }[period] || '#eaf5fb')
  : getSkin(skin).color;

export const readSavedSkin = () => {
  try {
    const saved = window.localStorage.getItem(SKIN_STORAGE_KEY);
    return isSkin(saved) ? saved : 'regular';
  } catch {
    return 'regular';
  }
};
